// removed by extract-text-webpack-plugin
module.exports = {"panel":"collapse__panel-1Wq3q","wide":"collapse__wide-1zfoJ","collapsed":"collapse__collapsed-3uaTp","wrapper":"collapse__wrapper-1pkbd","headerClickable":"collapse__headerClickable-2RAwi","header":"collapse__header-2pZDP","content":"collapse__content-1sASj","arrow":"collapse__arrow-O7nyZ"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/collapse/collapse.css
// module id = 814
// module chunks = 0